// extracted by mini-css-extract-plugin
export default {"rating":"LJ-z","numberOfStars":"MJ-z","count":"NJ-z","barGraphSpacing":"OJ-z","barGraph":"PJ-z"};